import { React, useState } from "react";
import { Link } from "react-router-dom";
import deleteIcon from "../../images/icons8-delete.svg";
import "./ImageCard.css";
import { deleteImage } from "../../services/Api";
import { useNavigate } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
} from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import ViewImageModal from "./ViewImageModal/ViewImageModal";
import axios from "axios";
import fileDownload from "js-file-download";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import { voteImage, unVoteImage } from "../../services/Api";
import { useToast } from "@chakra-ui/react";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

export default function Card(props) {
  // console.log(props);
  const toast = useToast();
  const navigate = useNavigate();
  const [vote, setVote] = useState(props.voted);

  const handleDelete = async () => {
    const data = await deleteImage(props.id);
    window.location.reload();
  };

  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  const handleVote = async () => {
    try {
      const data = await voteImage(props.id);
      if (data?.data?.status === "success") {
        setVote(true);
        toast({
          title: "Vote Image",
          description: `${data?.data?.message}`,
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      } else {
        setVote(false);
        toast({
          title: "Vote Image",
          description: `${data?.data?.message}`,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Error",
        status: `error`,
        duration: 9000,
        isClosable: true,
      });
    }
  };

  const handleUnVote = async () => {
    try {
      const data = await unVoteImage(props.id);
      if (data?.data?.status === "success") {
        setVote(false);
        toast({
          title: "Remove Vote",
          description: `${data?.data?.message}`,
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      } else {
        setVote(true);
        toast({
          title: "Remove Vote",
          description: `${data?.data?.message}`,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Remove Vote",
        description: `${error}`,
        status: `error`,
        duration: 9000,
        isClosable: true,
      });
    }
  };

  // console.log(props);
  return (
    <>
      <div
        className="property-card"
        style={{
          fontColor: "black",
          backgroundImage: `url("https://missionlife.iiita.ac.in//${props.url}")`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div id={props.id} className="id-container">
          <div className="property-image">
            <Menu>
              <MenuButton
                className="menu-button"
                as={Button}
                rightIcon={<MoreHorizIcon />}
              />
              <MenuList>
                {/* <MenuItem>
                </MenuItem> */}
                {props.userId === props.uid ||
                props.userType === "admin" ||
                props.userType === "superadmin" ? (
                  <>
                    <MenuItem onClick={handleDelete}>
                      Delete this image
                    </MenuItem>
                  </>
                ) : (
                  ""
                )}
                <MenuItem
                  onClick={() =>
                    handleDownload(
                      `https://missionlife.iiita.ac.in//${props.url}`,
                      `${props.id}${props.url.slice(
                        props.url.lastIndexOf(".")
                      )}`
                    )
                  }
                >
                  Download this image
                </MenuItem>
                <MenuItem>
                  <Link
                    to={`/gallery?uid=${props.uid}&username=${props.username}`}
                  >
                    View {props.username}'s images
                  </Link>
                </MenuItem>
              </MenuList>
            </Menu>
            <div className="property-image-title">
              <ViewImageModal props={props} />
            </div>
          </div>
        </div>
        <div className="property-description" style={{ color: "black" }}>
          <div className="name">
            <span style={{ fontWeight: "bold" }}>Name: </span>{" "}
            <span style={{ fontSize: "16px" }}>{`${props.username}`}</span>
          </div>
          <div className="time">
            <span style={{ fontWeight: "bold" }}>Timestamp: </span>{" "}
            <span style={{ fontSize: "14px" }}>
              {`${props.upload_time}`.slice(10)} on{" "}
              {`${props.upload_time}`.slice(0, 10)}
            </span>
          </div>
          <div
            className="property-description-reverse"
            style={{ color: "black" }}
          >
            {vote ? (
              <div className="vote" onClick={handleUnVote}>
                <FavoriteIcon style={{ fontSize: "2rem" }} />
                {props.votes} Votes
              </div>
            ) : (
              <div className="vote">
                <FavoriteBorderIcon
                  onClick={handleVote}
                  style={{ fontSize: "2rem" }}
                />
                {props.votes} Votes
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
